import { TSchema } from '@sinclair/typebox';
import { cloneDeep } from 'lodash';
import { getJsonSchemaValidator } from '../../../../common/src/utils/getJsonSchemaValidator';
import { emptyJsonSchemaValidationErrors } from './emptyJsonSchemaValidationErrors';
import { JsonSchemaValidationErrors } from './JsonSchemaValidationErrors';

export const ajv = getJsonSchemaValidator(true);

// Object that contains the last validation result, to be used in tests
export const lastValidationResultsForJest: { errors: any } = { errors: null };

export function validateJsonSchemaFormItem(schema: TSchema, item: any): { errors: JsonSchemaValidationErrors; hasErrors: boolean; item?: any } {
    const itemToValidate = cloneDeep(item);
    const validator = ajv.compile({ ...schema, additionalProperties: false });
    validator(itemToValidate);
    if (process.env.JEST_WORKER_ID) {
        lastValidationResultsForJest.errors = validator.errors;
    }
    if (validator.errors) {
        let errors = emptyJsonSchemaValidationErrors;
        for (const error of validator.errors) {
            if (error.params.missingProperty) {
                errors = errors.set(error.params.missingProperty, 'any_required');
            } else if (error.keyword === 'minLength') {
                errors = errors.set(error.instancePath.substr(1), 'any_required');
            } else if (error.keyword === '"minimum"') {
                errors = errors.set(error.instancePath.substr(1), 'any_required');
            } else if (error.instancePath) {
                errors = errors.set(error.instancePath.substr(1), 'any_required');
            } else {
                console.log('Unknown error', error);
            }
        }
        return { hasErrors: true, errors };
    }
    return { hasErrors: false, errors: emptyJsonSchemaValidationErrors, item: itemToValidate };
}
